export const chartDataPointKey = "recharts_chart_data_point_unique_key";
